import { GenIcon } from '../helpers/IconBase.es.js';

const ArrowUpFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M7.52331 15L16.4767 15C16.9233 15 17.1639 14.4733 16.8727 14.133L12.792 9.36523C12.3752 8.87826 11.6248 8.87826 11.208 9.36523L7.12731 14.133C6.83609 14.4732 7.07668 15 7.52331 15Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { ArrowUpFilled };
